import { createContext, useContext } from "react";
const ItemDragAndDropContext = createContext({
  isDragging: false,
  dragIndicator: null
});
function useItemDragAndDropContext() {
  const context = useContext(ItemDragAndDropContext);
  return context;
}
export {
  ItemDragAndDropContext,
  useItemDragAndDropContext
};
//# sourceMappingURL=context10.js.map
